import { useContext } from 'react'

import { AppModeContext } from '@web/contexts/appModeContext'

export default function useAppMode() {
  const context = useContext(AppModeContext)

  if (!context) {
    throw new Error('useAppMode must be used within an AppModeContextProvider')
  }

  return context
}
